import icon from "../../assets/port.svg";
import type { Property } from "../../types";

export const redundantRj45Port: Property = {
  id: "redundantRj45Port",
  title: "redundantRj45Port.title",
  icon,
};
